import { initToast } from '@/js/toast';

document.addEventListener('DOMContentLoaded', () => {
	initToast();
});
